module.exports = __webpack_public_path__ + "img/grid-backgound.5fc19d23.png";